var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApartmentFinderIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.823 40.5978C72.315 45.7759 73.1274 54.5354 67.3605 62.3482C57.8749 75.2592 39.4415 73.3431 38.4346 73.2176C30.9206 72.1103 23.9407 68.6933 18.4679 63.4431C14.0512 59.6793 5.40091 52.1972 5.01188 40.5978C4.70294 30.8004 10.5041 23.9001 12.8155 21.0373C14.4631 19.0527 23.411 8.25171 38.4346 8.00078C45.8139 7.95009 52.9987 10.3587 58.8475 14.8441C70.2325 23.5009 71.4683 36.5602 71.823 40.5978Z",
    stroke: "#030201",
    strokeWidth: 1.14384,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8575 45.9389C42.359 47.8113 39.343 48.8683 36.2209 48.9656C33.0988 49.0629 30.0227 48.1959 27.4122 46.4827C20.7452 42.2213 19.1562 32.7883 24.6009 27.0731C29.779 21.6242 39.135 22.0792 44.4908 26.7956C50.2133 31.7008 49.5799 40.3125 45.2241 45.8502C44.7686 46.3939 45.5797 47.2041 46.0353 46.6603C50.7577 40.6787 51.1244 32.8771 46.1242 26.8844C41.224 20.7253 30.779 20.6254 24.8787 25.2531C18.334 30.4245 18.9673 38.7699 23.7676 44.8514C29.0456 51.5099 38.7572 51.5654 45.3019 46.9377C46.0242 46.5715 45.3908 45.5727 44.8464 45.9389H44.8575Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6792 47.3908C50.3017 51.8298 55.7909 56.4575 61.1134 61.2739C61.6578 61.7178 62.4801 60.9964 61.9356 60.4526C56.4798 55.6474 51.0018 51.0197 45.4459 46.5696C44.9015 46.1146 44.0792 46.9358 44.7237 47.3908H44.6792Z",
    fill: "#030201"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0465,
    height: 39.4185,
    fill: "white",
    transform: "translate(20.0669 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentFinderIconNew);
export default __webpack_public_path__ + "static/media/apartment-finder-icon-new.097f92ff47450664a7f8bea2330e875c.svg";
export { ForwardRef as ReactComponent };